<template>
  <div class="answers_multichoice">
    <vchecklabel
      v-for="item in data"
      :key="item.id"
      class="answer"
      :value="selected_ids.indexOf(item.id) > -1"
      :label="item.body"
      :disabled="isDisabled"
      @input="set_selected_ids($event, item.id)"
    />
  </div>
</template>

<script>
  export default {
    name: 'answers_multichoice',
    props: ['data', 'isDisabled'],
    data() {
      return {
        selected_ids: []
      };
    },
    methods: {
      set_selected_ids(v, id) {
        let result = [];
        if (v) {
          this.selected_ids.push(id);
        } else {
          let p = this.selected_ids.indexOf(id);
          this.selected_ids.splice(p, 1);
        }
        this.selected_ids.forEach(i => {
          result.push({ id: i });
        });
        this.$emit('update', result);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .answers_multichoice {
    ::v-deep .answer.vcheckbox_label {
      cursor: pointer;
      margin-bottom: 8px;
      padding: 0;
      &:hover {
        background: transparent;
      }

      &:last-child {
        margin-bottom: 0;
      }
      .checkbox_label {
        font-size: 15px;
        line-height: 24px;
      }
    }
  }
</style>
